import React, { Component } from 'react';
import { Input, Form, Row, Col, Modal, message, Button } from 'antd';
import { Message } from 'semantic-ui-react'
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';


const FormItem = Form.Item;
const TextArea = Input.TextArea;

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};


class DelOrAuditAccountDialog extends Component {
    componentDidMount() {

    }

    componentDidUpdate() {
        const {
            delOrAuditAccountModal,
            delPersonalAccountActionStatus,
            changePersonalAccountStatusActionStatus,
        } = this.props;
        if(delPersonalAccountActionStatus === ACTION_STATUS.SUCCESS) {
            message.success('Delete Personal Account succeeded');
            this.props.initDelPersonalAccountActionStatus();
            this.props.resetDelOrAuditAccountDialog();
            const {
                id,
                employee,
            } = this.props.personalAccountQueryFields;
            const param = {
                id,
                employee,
                approvalStatus: '',
                needHoldingData: 'true',
                source: 'Admin',
            }
            this.props.loadPersonalAccount(param);
        }
        if(delPersonalAccountActionStatus === ACTION_STATUS.ERROR) {
            this.props.initDelPersonalAccountActionStatus();
        }
        if(changePersonalAccountStatusActionStatus === ACTION_STATUS.SUCCESS) {
            const action = this.getActionFromMode(delOrAuditAccountModal.mode);
            message.success(action + ' Personal Account succeeded');
            this.props.initChangePersonalAccountStatusActionStatus();
            this.props.resetDelOrAuditAccountDialog();
            const {
                id,
                employee,
            } = this.props.personalAccountQueryFields;
            const param = {
                id,
                employee,
                approvalStatus: '',
                needHoldingData: 'true',
                source: 'Admin',
            }
            this.props.loadPersonalAccount(param);
            this.props.queryPendingTasksNum();  // 刷新PendingTasks任务数量
        }
        if(changePersonalAccountStatusActionStatus === ACTION_STATUS.ERROR) {
            this.props.initChangePersonalAccountStatusActionStatus();
        }
    }

    getActionFromMode(mode) {
        if(mode === 'DEL') {
            return 'Delete';
        } else if(mode === 'APPROVE') {
            return 'Approve';
        } else if(mode === 'FINALAPPROVE') {
            return 'Final Approve';
        } else {
            return 'Reject';
        }
    }


    submitDelOrAuditAccount = () => {
        const {
            mode,
            accountBean,
            fields,
        } = this.props.delOrAuditAccountModal;
        accountBean.comments = fields.comments;
        accountBean.mode = mode;
        accountBean.source = 'Admin';
        Modal.confirm({
            title: 'Are you sure to ' + this.getActionFromMode(mode) + ' this Person Account?',
            onOk: () => {
                if(mode === 'DEL') {
                    this.props.delPersonalAccount(accountBean);
                } else {
                    this.props.changePersonalAccountStatus(accountBean);
                }
            }
        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            delOrAuditAccountModal,
            delPersonalAccountActionStatus,
            changePersonalAccountStatusActionStatus,
        } = this.props;
        const {
            isOpened,
            mode,
            respErrMsg,
            accountBean,
            fields,
        } = delOrAuditAccountModal;
        const {
            comments,
        } = fields;


        const modalTitle = this.getActionFromMode(mode) + ' Personal Account';
        const isSubmitLoading = delPersonalAccountActionStatus === ACTION_STATUS.LOGINING || changePersonalAccountStatusActionStatus === ACTION_STATUS.LOGINING;

        return (
            <div>
                <Modal
                    title={modalTitle}
                    centered
                    width={800}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetDelOrAuditAccountDialog()}
                    footer={[
                        <Button key="Cancel" onClick={() => this.props.resetDelOrAuditAccountDialog() }>
                          Cancel
                        </Button>,
                        <Button key="Submit" type="primary" loading={isSubmitLoading} onClick={() => this.submitDelOrAuditAccount() }>
                          Submit
                        </Button>,
                    ]}
                >
                    <Form layout="horizontal">

                        <Row gutter={24}>
                             <Col span={24}>
                                <FormItem {...formItemLayout} label="comments">
                                    {getFieldDecorator('comments', {
                                        initialValue: comments,
                                        rules: [{
                                            required: false,
                                            message: '',
                                        }],
                                        })(
                                        <TextArea 
                                            style={{ width: 300, marginLeft: 10 }}
                                            rows={4} 
                                            placeholder='comments' 
                                            onChange={(e) => {
                                                this.props.onDelAuditAccountInputChange({ name: 'comments', value: e.target.value })
                                        }}/>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                    </Form>
                    {
                        !!respErrMsg &&  
                        <Message negative>
                            <Message.Header>Response Error Message</Message.Header>
                            <p>{ respErrMsg }</p>
                        </Message>
                    }
                </Modal>
            </div>
        );
    }

}


const DelOrAuditAccountDialogForm = Form.create({ name: 'DelOrAuditAccountDialog' })(DelOrAuditAccountDialog);
export default DelOrAuditAccountDialogForm;
